import { getSegmentAnalytics } from './segment';
import { ifSegmentAnalyticsEnabled } from '../utils/analyticsUtils';
import store from '@/store';
import PlayOnline from '@/utils/marketing/Providers/PlayOnline';

export const logSegmentRegistrationStep = ifSegmentAnalyticsEnabled((step: number) => {
  try {
    const analytics = getSegmentAnalytics();
    if (!analytics) {
      // console.warn('Segment Analytics not initialized');
      return;
    }

    const eventName = `step_${step}_register`;

    analytics.track(eventName, { brandId: window.config.clientId || 'unknown' });
  } catch (error) {
    // console.error('Error logging Segment registration step event:', error);
  }
});

export const logSegmentRegistrationComplete = ifSegmentAnalyticsEnabled((fields?: any) => {
  try {
    const analytics = getSegmentAnalytics();
    if (!analytics) {
      // console.warn('Segment Analytics not initialized');
      return;
    }

    const profileState = store.getState().profile;
    const brandId_userId = `${window.config.clientId || 'unknown'}_${profileState?.client_player_id || 'unknown'}`;

    // Identify the user with their registration data
    const identifyTraits: any = {
      brandId: window.config.clientId || 'unknown',
    };

    // Extract and add available user traits from fields
    if (fields?.email?.value) identifyTraits.email = fields.email.value;
    if (fields?.phone?.value) identifyTraits.phone = fields.phone.value;
    if (fields?.firstName?.value) identifyTraits.firstName = fields.firstName.value;
    if (fields?.lastName?.value) identifyTraits.lastName = fields.lastName.value;
    if (fields?.username?.value) identifyTraits.username = fields.username.value;
    if (fields?.nin?.value) identifyTraits.nin = fields.nin.value;
    identifyTraits.brandId_userId = brandId_userId;

    // Call identify to link the user
    analytics.identify(brandId_userId, identifyTraits);

    // Track the registration completion event
    analytics.track('web_registration_complete', {
      brandId_userId,
      gbraid: PlayOnline.getSavedField('gbraid'),
      wbraid: PlayOnline.getSavedField('wbraid'),
      gclid: PlayOnline.getSavedField('gclid'),
    });
  } catch (error) {
    // console.error('Error logging Segment registration complete event:', error);
  }
});
